import { environment } from "src/environments/environment";

export class Local {
  static debug(...args: any[]): void {
    if (!environment.production) {
      console.debug.apply(console, Local.prefix(args));
    }
  }

  static log(...args: any[]): void {
    if (!environment.production) {
      console.log.apply(console, Local.prefix(args));
    }
  }

  static prefix(args: any[]): any[] {
    const argArray = Array.prototype.slice.call(args);
    argArray.unshift("[BB8] ");
    return argArray;
  }
}
